
import { values } from '@/assets/mappings.json';

export default {
  props: {
    value: {
      type: Object,
      required: false,
      default: undefined
    },
    currency: {
      type: String,
      required: false,
      default: 'EUR'
    },
    hasMoreLots: {
      type: Boolean
    }
  },
  data () {
    return {
      values,
      open: this.hasMoreLots || !this.value
    };
  },
  computed: {
    description () {
      if (this.value && this.value.totalValue) {
        return this.getFieldName(this.value.field).replace('{{value}}', `<strong>${this.formatValue(this.value.value)}</strong>`);
      };

      return '';
    },

    totalDescription () {
      if (this.value) {
        return this.getFieldName(this.totalValue.field).replace('{{value}}', `<strong>${this.formatValue(this.totalValue.value)}</strong>`);
      };

      return '';
    },

    totalValue () {
      if (!this.value) { return; }
      if (this.value?.totalValue && this.hasMoreLots) {
        return {
          value: this.value.totalValue,
          field: this.value.totalField
        };
      }

      return {
        value: this.value.value,
        field: this.value.field
      };
    }
  },

  mounted () {
    const completedTutorials = JSON.parse(localStorage.getItem('completed_tutorials') ?? '[]');
    if (completedTutorials.includes('value_unknown')) {
      this.open = false;
    }
  },

  methods: {
    formatValue (value) {
      const result = this.$options.filters.formatPrice(value, this.currency);

      if (value < 500) { return result + ' per uur'; }

      return result;
    },

    getFieldName (field) {
      if (values[field + '&multipleLots'] && this.hasMoreLots) {
        return values[field + '&multipleLots'];
      }

      return values[field];
    },

    toggle () {
      this.open = !this.open;

      if (!this.open) {
        const completedTutorials = JSON.parse(localStorage.getItem('completed_tutorials') ?? '[]');

        completedTutorials.push('value_unknown');

        localStorage.setItem('completed_tutorials', JSON.stringify(completedTutorials));
      }
    }
  }
};
